import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-contessa-50">
      <Header />
      <main className="flex-grow container mx-auto bg-white shadow-2xl xl:rounded-2xl xl:my-6 overflow-clip">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 